import { Ficello } from '@captaincause/ui/Ficello'
import { tm } from '@captaincause/ui/tm'
import { Button } from 'components/Button'
import type { Locales } from '@captaincause/types'
import type { FicelloStroke } from '@captaincause/ui/Ficello'
import type { StrapiLink } from 'types/strapi/link'

type FicelloSet = 'green-orange' | 'purple-green' | 'orange-purple'

export interface CallToActionProps {
  className?: string
  title: string | null
  link: StrapiLink | null
  ficellos?: FicelloSet | null
  locale?: Locales | false
  contained?: boolean
  withoutContainerPadding?: boolean
}

const FICELLOS_COLORS: Record<FicelloSet, FicelloStroke[]> = {
  'green-orange': ['green', 'orange'],
  'purple-green': ['purple', 'green'],
  'orange-purple': ['orange', 'purple'],
}

export default function CallToAction({
  className = undefined,
  title,
  link,
  ficellos = null,
  locale = undefined,
  contained = false,
  withoutContainerPadding = false,
}: CallToActionProps) {
  const ficellosColors = FICELLOS_COLORS[ficellos ?? 'green-orange']

  return (
    <div
      className={tm(
        contained &&
          'm-auto w-full max-w-[1400px] overflow-hidden px-4 py-10 md:px-20 md:py-10',
        withoutContainerPadding &&
          'px-[unset] py-[unset] md:px-[unset] md:py-[unset]',
        className,
      )}
    >
      <div
        className={tm(
          'relative flex h-auto w-full flex-col items-center justify-center overflow-hidden bg-light-beige px-8 py-6 md:h-[240px]',
          contained && 'rounded-3xl md:h-auto',
        )}
      >
        <Ficello
          variant="raye"
          stroke={ficellosColors[0]}
          className="absolute -top-[438px] right-[18em] rotate-180 -scale-[0.75] xl:-left-[500px] xl:right-[unset]"
        />
        <Ficello
          variant="raye"
          stroke={ficellosColors[1]}
          className="absolute -top-[438px] left-[28em] rotate-180 -scale-[0.75] xl:-right-[650px] xl:left-[unset]"
        />
        <div className="relative mb-6">
          <div
            className={tm(
              'z-40 max-w-[800px] text-center text-3xl font-semibold leading-8 md:leading-[40px]',
              contained && 'max-w-xl',
            )}
          >
            {title}
          </div>
        </div>
        {link?.url ? (
          <Button
            href={link.url}
            variant="primary"
            iconRight="arrow-go"
            small
            large
            locale={locale}
          >
            {link.title}
          </Button>
        ) : null}
      </div>
    </div>
  )
}
